// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-image-lightbox/style.css';

import { Trash2 } from 'lucide-react';
import React, { useLayoutEffect, useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Lightbox from 'react-image-lightbox';

import { DraggedCardWrapper } from '../DraggedCardWrapper';
import { ButtonRemove, GalleryContainer, GalleryItem } from './LightboxGallery.styled';

interface LightboxGalleryProps {
  draggedCards: { id: string; order: number }[];
  title?: string;
  isPendingOrderChange?: boolean;
  hoveredIndex?: number | null;
  handleDragOver?: (e: React.DragEvent) => void;
  handleDragEnter?: (index: number) => void;
  handleDrop?: (e: React.DragEvent, dropIndex: number) => void;
  handleDragStart?: (e: React.DragEvent, index: number) => void;
  handleDragEnd?: () => void;
  isDragging?: boolean;
  imageParams?: string;
  onRemove?: (index?: number) => void;
}

export const LightboxGallery: React.FC<LightboxGalleryProps> = ({
  draggedCards,
  title,
  isPendingOrderChange,
  hoveredIndex,
  handleDragOver,
  handleDragEnter,
  handleDrop,
  handleDragStart,
  handleDragEnd,
  isDragging,
  imageParams,
  onRemove,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  useLayoutEffect(() => {
    if (isOpen) {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    }
  }, [isOpen]);

  if (draggedCards.length === 0) return null;
  return (
    <>
      {title && <h3 className="mb-2.5 mt-5">{title}</h3>}
      <GalleryContainer>
        {draggedCards.map((item, index) => (
          <DraggedCardWrapper
            key={item.order}
            isHovered={hoveredIndex === index}
            onDragOver={handleDragOver}
            onDragEnter={() => handleDragEnter && handleDragEnter(index)}
            onDrop={(e) => handleDrop && handleDrop(e, index)}
            onDragStart={(e) => handleDragStart && handleDragStart(e, index)}
            onDragEnd={handleDragEnd}
            isDragging={!isPendingOrderChange && isDragging}
          >
            {onRemove && (
            <ButtonRemove
              onClick={() => onRemove(index)}
            >
              <Trash2 size={12} strokeWidth={1.5} />
            </ButtonRemove>
            )}
            <GalleryItem
              src={`${item.id}?${imageParams}`}
              alt={`Miniatura ${index + 1}`}
            /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */
              role="button"
              tabIndex={0}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
            />
          </DraggedCardWrapper>
        ))}
      </GalleryContainer>
      {isOpen && (
      <Lightbox
        mainSrc={draggedCards[photoIndex].id || ''}
        nextSrc={draggedCards[(photoIndex + 1) % draggedCards.length].id || ''}
        prevSrc={draggedCards[(photoIndex + draggedCards.length - 1) % draggedCards.length].id || ''}
        onCloseRequest={() => setIsOpen(false)}
        onMovePrevRequest={() => setPhotoIndex((photoIndex + draggedCards.length - 1) % draggedCards.length)}
        onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % draggedCards.length)}
        animationDisabled
      />
      )}
    </>
  );
};
